import '../utils/antdReact19Compat'
import { initDatadog } from '../utils/datadog'
/** dd-rum needs to be imported before anything else to properly hook all app modules */
import { ConfigProvider } from 'antd'
import { SessionProvider } from 'next-auth/react'
import { AppProps } from 'next/dist/shared/lib/router/router'
import { useRouter } from 'next/router'

import { FooterProvider } from 'src/components/common/FooterBar/FooterContext'
import TopNavBar from 'src/components/common/TopNavBar/TopNavBar'
import { appRoutesWithoutTopNavBar } from 'src/constants/appRoutes'
import LoaderContextProvider from 'src/context/LoaderContext/LoaderContextProvider'
import '../src/global.css'
import { poppins, theme } from '../src/helpers/themeHelper'
import '../src/index.css'
import { Provider } from 'jotai'
import { store } from 'src/store/useStore'
import { useEffect } from 'react'

export default function MyApp({ Component, session, pageProps }: AppProps) {
    const router = useRouter()
    const topNavBarVisible = !Object.values(appRoutesWithoutTopNavBar)
        .map((x) => x.path)
        .includes(router.pathname)

    useEffect(() => {
        initDatadog()
    }, [])

    return (
        <SessionProvider session={session} refetchInterval={5 * 60}>
            {/* Defines global styling for Ant Design elements */}
            <ConfigProvider theme={theme}>
                <LoaderContextProvider>
                    {/* Defines global styling for non-Ant Design elements */}
                    <Provider store={store}>
                        <div className={poppins.className}>
                            <FooterProvider>
                                {topNavBarVisible && <TopNavBar />}
                                <main>
                                    <Component {...pageProps} />
                                </main>
                            </FooterProvider>
                        </div>
                    </Provider>
                </LoaderContextProvider>
            </ConfigProvider>
        </SessionProvider>
    )
}
